import React, { useState } from "react";
import { handleMerchantRequests } from "../services/merchant";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";

const ApprovalMerchantRequestModal = ({ setShowApprove, user }) => {
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await handleMerchantRequests(user.Id, {
        status: "approved",
        comment,
      });
      toast.success(res.message);
      setLoading(false);
      queryClient.invalidateQueries({ queryKey: ["getMerchantRequests"] });
      setShowApprove(false);
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex justify-center items-center">
      <div className="modal-content flex flex-col justify-center h-fit w-[400px] bg-white p-6 rounded shadow-lg relative">
        <button
          className="close absolute top-3 right-2 py-1 cursor-pointer px-4 text-orange-400 border border-orange-400 rounded-md"
          onClick={() => setShowApprove(false)}
        >
          x
        </button>
        <form className="flex flex-col" onSubmit={handleSubmit}>
          <div className="flex flex-col gap-4 mt-8">
            <div className="flex flex-col">
              <label htmlFor="comment">Comment</label>
              <textarea
                name="comment"
                placeholder="Leave a comment.."
                required
                onChange={(e) => setComment(e.target.value)}
                className="w-[350px] h-[150px] bg-gray-100 outline-none pt-7 px-2 rounded-[.5rem] pl-[.5rem] mt-3"
              />
            </div>
          </div>
          <button
            type="submit"
            className=" flex items-center justify-center bg-primary px-4 mt-8 text-white py-2 mr-2 rounded-md"
          >
            {loading ? (
              <span>
                {" "}
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
              </span>
            ) : (
              "Approve"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ApprovalMerchantRequestModal;
